import AuthStore from 'common/authStore';
// import { NAVIGATION } from 'common/constants';
import AUTH_CONFIG from 'utils/authConfig';
import { Modal } from 'antd';
import './index.scss';

function WarningModal() {
  const handleClickOnLogout = () => {
    // localStorage.clear();
    AuthStore.emptyStore();
    localStorage.removeItem('usertype');

    window.location.href = `${window.location.origin.toString()}${AUTH_CONFIG.appBasePath}`;
  };

  return (
    <Modal
      className="sessinmodal"
      title="Session Expired"
      open={true}
      closable={false}
      footer={null}
    >
      <h2>
        Your session has expired.{' '}
        <span className="logoutbtn-session" onClick={handleClickOnLogout}>
          Click here to login
        </span>
      </h2>
    </Modal>
  );
}
export default WarningModal;
